module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_an_black-6e72d1511afdf6b6c65d42b2e43fd1b1.svg";